import React from 'react';
import { Link } from 'react-router-dom';
import { PageTitle, PageSubTitle } from 'Components/Titles';
import RoundedPanel from 'Components/RoundedPanel';
import { Loader } from 'Components/Loader';
import { ErrorBoundary } from 'Components/ErrorBoundary/ErrorBoundary';
import { classCombine } from 'Utils/Utils';
import { StatusIndicator } from 'Components/StatusIndicator';
import './CenterFrameLayout.css';

function CenterFrameLayout({
  children,
  title,
  subtitle,
  status,
  statusType,
  noPanel,
  modernLayout,
  customClass = '',
  customFrameClass = '',
  showLoader,
  panelStyle,
  goBack = '',
  backUrl = '/',
  mobileTitle,
  mobileSubtitle,
  pageTitleClass,
  pageSubTitleClass,
}) {
  return (
    <ErrorBoundary name="center frame">
      <div
        className={classCombine(
          'centerFrameLayout',
          modernLayout && 'modernLayout',
          !title && 'topMargin',
          customClass
        )}
      >
        {(title || showLoader) && (
          <PageTitle
            modernLayout={modernLayout}
            text={title}
            alignText="center"
            customClass={classCombine(!!mobileTitle && 'desktopOnly', pageTitleClass)}
          />
        )}
        {mobileTitle && (
          <PageTitle
            modernLayout={modernLayout}
            text={mobileTitle}
            alignText="center"
            customClass={classCombine('mobileOnly', pageTitleClass)}
          />
        )}
        {subtitle && (
          <PageSubTitle
            text={subtitle}
            alignText="center"
            customClass={classCombine(!!mobileSubtitle && 'desktopOnly', pageSubTitleClass)}
          />
        )}
        {mobileSubtitle && (
          <PageSubTitle
            text={mobileSubtitle}
            alignText="center"
            customClass={classCombine('mobileOnly', pageSubTitleClass)}
          />
        )}
        {status && !showLoader && <StatusIndicator status={status} type={statusType} />}
        {goBack && (
          <Link to={backUrl} className="backButton">
            <img
              className="backIcon"
              src="/account/static/images/arrow-back-white.svg"
              width="20"
              height="20"
              alt="back-arrow"
            />
            <span className="backText">{goBack}</span>
          </Link>
        )}
        <RoundedPanel noPanel={noPanel} style={panelStyle}>
          <div className={classCombine('frameContentContainer', customFrameClass, showLoader && 'loading')}>
            {showLoader ? <Loader /> : children}
          </div>
        </RoundedPanel>
      </div>
    </ErrorBoundary>
  );
}

export default CenterFrameLayout;
